import './videoblog.scss'
import { Layouts } from '../../../component/layouts/layouts'

export const Blog15 = () => {
  return (
    <Layouts>
      <div className='flex flex-col items-center justify-center px-10 sm:px-20 md:px-30 lg:px-40'>
        <div className='w-full max-w-1000 flex flex-col gap-10 md:gap-20 lg:gap-30 py-30'>
          <div className='text-center text-20 md:text-30 lg:text-40 font-semibold'>
            Kedy.ai - The Online Cloud-Based Video Editor: Our Journey and Development Process
          </div>

          <div className='flex flex-col gap-10 mm:gap-20'>
            <div className='text-15 md:text-18'>
              At Kedy.ai, we are proud to offer our cloud-based online video editor, which enables content creators to create professional-looking videos easily. Our online video editor has been developed with the aim of providing an easy-to-use interface that makes video editing accessible to everyone. In this article, we will discuss how we developed Kedy.ai and the features that make it stand out from other online video editors.
            </div>

            <div className='text-15 md:text-18'>
              <span className='font-semibold'>1. Our Journey</span>
            </div>

            <div className='text-15 md:text-18'>
              The journey of developing Kedy.ai started with the realization that video content was becoming a significant part of digital marketing. We wanted to provide a tool that made video editing accessible and easy for everyone, regardless of their skill level. We started by researching different technologies and software to find the best tools to use for our platform.
            </div>

            <div className='text-15 md:text-18'>
              <span className='font-semibold'>2. Development Process</span>
            </div>

            <div className='text-15 md:text-18'>
              We chose to develop Kedy.ai using the latest web technologies, including HTML5, CSS, and JavaScript. This enabled us to create an online video editor that is compatible with any browser and operating system. Our team of developers worked tirelessly to ensure that the video editor's functionality was user-friendly, and it would allow users to create professional-looking videos with ease.
            </div>

            <div className='text-15 md:text-18'>
              <span className='font-semibold'>2.1 FFMPEG</span>
            </div>

            <div className='text-15 md:text-18'>
              FFMPEG is an open-source multimedia framework that is widely used in the video editing industry. We utilized FFMPEG to implement various video editing features such as cutting, trimming, merging, and format conversion in our platform. FFMPEG allowed us to handle various video formats, codecs, and resolutions, making our platform compatible with a wide range of video files.
            </div>

            <div className='text-15 md:text-18'>
              <span className='font-semibold'>2.2 WebGL and OpenGL</span>
            </div>

            <div className='text-15 md:text-18'>
              WebGL and OpenGL are graphics libraries that enable developers to create complex and high-performance graphics in web applications. We used these libraries to optimize the video rendering process and ensure that users can preview their edits in real-time. By utilizing the GPU (Graphics Processing Unit) of the user's device, we were able to render videos quickly and efficiently, providing a smooth editing experience for our users.
            </div>

            <div className='text-15 md:text-18'>
              <span className='font-semibold'>2.3 Google Cloud and Amazon Web Services</span>
            </div>

            <div className='text-15 md:text-18'>
              To ensure the scalability and reliability of our platform, we utilized the cloud infrastructure provided by Google Cloud and Amazon Web Services. These cloud services allowed us to store large amounts of video data securely and ensure that the video editing process remains uninterrupted. We also utilized other cloud-based services such as Cloudflare for content delivery and Firebase for real-time database management.
            </div>

            <div className='text-15 md:text-18'>
              In conclusion, by utilizing a combination of web technologies, multimedia frameworks, graphics libraries, and cloud infrastructure, we were able to develop Kedy.ai, a powerful and user-friendly cloud-based online video editor. Our focus on utilizing the latest technologies and tools has allowed us to provide our users with a seamless video editing experience, regardless of their device or operating system.
            </div>

            <div className='text-15 md:text-18'>
              <span className='font-semibold'>2.4 React</span>
            </div>

            <div className='text-15 md:text-18'>
              React is a JavaScript library that we utilized in the development of Kedy.ai. React is widely used in web development to create user interfaces and is known for its performance, scalability, and ease of use.
            </div>

            <div className='text-15 md:text-18'>
              We used React to create the user interface for Kedy.ai, allowing us to create a fast and responsive experience for our users. React's component-based architecture enabled us to create reusable components, reducing development time and improving the maintainability of our codebase.
            </div>

            <div className='text-15 md:text-18'>
              React also allowed us to create a dynamic and interactive user interface that responds to user input in real-time. By utilizing React's virtual DOM, we were able to update the user interface efficiently and provide a smooth editing experience for our users.
            </div>

            <div className='text-15 md:text-18'>
              Overall, React was a crucial component in the development of Kedy.ai, allowing us to create a fast, responsive, and interactive user interface that provides a seamless video editing experience for our users.
            </div>

            <div className='text-15 md:text-18'>
              <span className='font-semibold'>3. Features</span>
            </div>

            <div className='text-15 md:text-18'>
              One of the most notable features of Kedy.ai is its easy-to-use interface. We designed it to be intuitive and straightforward so that anyone, regardless of their skill level, can use it. We also made sure that the video editor is compatible with multiple platforms, including iOS, Android, and Linux.
            </div>

            <div className='text-15 md:text-18'>
              Another significant feature of Kedy.ai is its real-time collaboration feature. This allows multiple users to work on a video project simultaneously, enabling teams to collaborate efficiently and effectively.
            </div>

            <div className='text-15 md:text-18'>
              We also ensured that Kedy.ai has robust security measures in place to protect user data and ensure the confidentiality of sensitive information.
            </div>

            <div className='text-15 md:text-18'>
              <span className='font-semibold'>A final word ...</span>
            </div>

            <div className='text-15 md:text-18'>
              At Kedy.ai, we are proud to offer a cloud-based online video editor that is accessible, easy-to-use, and secure. Our development team worked hard to create a tool that is compatible with multiple platforms and enables users to create professional-looking videos with ease. We believe that Kedy.ai is an ideal tool for content creators, businesses, and individuals who want to create high-quality videos that engage and promote their brand.
            </div>
          </div>
        </div>
      </div>
    </Layouts>
  )
}